<template>
  <SideMenu
    ref="sideMenu"
    :heading="voucherHeading"
    :side="'right'"
    @on-side-menu-close="$emit('onVoucherMenuClose')"
  >
    <div class="p-24">
      <TextInput
        :placeholder="voucherPlaceholder"
        :has-error="voucherStatus === LoadingStatuses.ERROR"
        :icon="voucherStatus === LoadingStatuses.SUCCESS ? 'check' : ''"
        :icon-style="'far'"
        :border-color="'#979D95'"
        :icon-color="'#505A4B'"
        :is-loading="voucherStatus === LoadingStatuses.LOADING"
        @submit-input="(input) => voucher = input"
      />
      <div
        v-if="voucherStatus === LoadingStatuses.ERROR"
        class="text-xxs text-warning mt-12"
      >
        {{ $lang('checkout', 'voucher_error') }}
      </div>
      <ButtonComponent
        class="mt-12"
        is-large-btn
        is-block
        :text="$lang('checkout', 'voucher_select_btn')"
        @click="applyVoucher"
      />
    </div>
  </SideMenu>
</template>

<script setup lang="ts">
import type { Ref } from 'vue';
import ButtonComponent from '~/components/forms/ButtonComponent.vue';
import SideMenu from '~/components/navigation/SideMenu.vue';
import TextInput from '~/components/forms/TextInput.vue';
import LoadingStatuses from '~/constants/loading-statuses';
import { useCartStore } from '~/store/cart';
import type { CartType } from '~/constants/types/cart';
const { centraPost, centraDelete } = useApiFetch();
const cartStore = useCartStore();
const { $lang } = useNuxtApp();
const { sellerCookieOptions } = useCookieConfig();

const isSeller = useCookie<boolean>('isSeller', sellerCookieOptions) as Ref<boolean>;

const emit = defineEmits<{
  (e: 'onVoucherMenuClose'): void;
  (e: 'suspendKco'): void;
  (e: 'resumeKco'): void;
  (e: 'voucherApplied'): void;
}>();

const voucherCode = ref('');
const voucher = ref('');
const voucherStatus = ref('');

const sideMenu = ref<typeof SideMenu | null>(null);
onMounted(()=> {
  if (sideMenu.value) {
    sideMenu.value.openOverlay();
  }
});

const voucherHeading = computed(() => {
  if (isSeller.value) {
    return $lang('checkout', 'return_code');
  } else {
    return $lang('checkout', 'voucher_heading');
  }
});

const voucherPlaceholder = computed(() => {
  if (isSeller.value) {
    return $lang('checkout', 'input_return_code');
  } else {
    return $lang('checkout', 'voucher_placeholder');
  }
});

const suspendKco = () => {
  if (window._klarnaCheckout) {
    window._klarnaCheckout(function(api: { suspend: () => void }) {
      api.suspend();
    });
  }
};
const resumeKco = () => {
  if (window._klarnaCheckout) {
    window._klarnaCheckout(function(api: { resume: () => void }) {
      api.resume();
    });
  }
};

const applyVoucher = async() => {
  voucherStatus.value = LoadingStatuses.LOADING;
  emit('suspendKco');

  if (!voucher) {
    voucherStatus.value = '';
  } else {
    const res = await centraPost<CartType>('/vouchers', {
      voucher: voucher.value,
    });
    if (res) {
      const voucherCount = res.selection.discounts?.vouchers.length - 1 || 0;
      console.log('vouchers: ' + voucherCount);
      console.log('voucher: ' + JSON.stringify(res.selection.discounts));
      console.log('condition 1: ' + res.selection.discounts?.vouchers[voucherCount].attributes.voucher_sellerlink_enabled=='1');
      console.log('condition 2: ' + res.selection.discounts?.vouchers[voucherCount].description.toLowerCase().includes('retur'));
      if (isSeller.value && !(res.selection.discounts?.vouchers[voucherCount].attributes.voucher_sellerlink_enabled=='1' || res.selection.discounts?.vouchers[voucherCount].description.toLowerCase().includes('retur'))) {
        suspendKco();
        const res = await centraDelete<CartType>(`/vouchers/${voucher.value}`);
        if (res) {
          cartStore._cartData = res;
        }
        resumeKco();
        setTimeout(() => {
          voucherStatus.value = LoadingStatuses.ERROR;
        }, 1000);
      } else {
        cartStore._cartData = res;
        emit('voucherApplied');
      }
    } else {
      setTimeout(() => {
        voucherStatus.value = LoadingStatuses.ERROR;
      }, 1000);
    }
  }
  emit('resumeKco');
};

</script>
